import moment from 'moment';

window.parsedMoment = (date) => {
  if (moment.parseZone(date).format('DD/MM/YYYY').toLowerCase() === 'invalid date') {
    return moment.parseZone(date, 'DD/MM/YYYY');
  }
  return moment.parseZone(date);
};
